import { useEffect, useState } from "react";
import { FaUserTie, FaHandshake } from "react-icons/fa";

function Agents() {
  const [ctaVisible, setCtaVisible] = useState(false);

  useEffect(() => {
    // Animate value boxes with stagger
    const boxes = document.querySelectorAll(".highlight-box");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("show");
              observer.unobserve(entry.target);
            }, i * 150);
          }
        });
      },
      { threshold: 0.2 }
    );
    boxes.forEach((box) => observer.observe(box));

    // Show CTA after last box animation delay
    const delayStep = 150;
    const boxDuration = 800;
    const totalTime = (boxes.length - 1) * delayStep + boxDuration;

    const timer = setTimeout(() => {
      setCtaVisible(true);
    }, totalTime);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <section className="agents-section bg-default text-center" id="agents">
        <div className="container px-4 px-lg-5">

          {/* === HERO TITLE === */}
          <h1 className="text-white mb-3 big-title">Solicitors & Estate Agents</h1>
          <p className="text-white-80 lead hero-subtext">
            Partner with us to help your clients navigate Capital Gains Tax 
            with ease — and earn rewards for every successful referral.
          </p>

          {/* === VALUE BOXES === */}
          <div className="row gx-4 gy-4 justify-content-center mt-5">
            <div className="col-md-4 d-flex">
              <div className="highlight-box flex-fill">
                <FaUserTie className="highlight-icon" />
                <h5 className="text-white">Expert Tax Support</h5>
                <p className="text-white-80">
                  We handle the complex CGT process so you can focus on what you do best.
                </p>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="highlight-box flex-fill">
                <FaHandshake className="highlight-icon" />
                <h5 className="text-white">Client-Centric Partnership</h5>
                <p className="text-white-80">
                  Our shared goal is your client’s success and peace of mind.
                </p>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="highlight-box flex-fill">
                <FaUserTie className="highlight-icon" />
                <h5 className="text-white">Earn for Referrals</h5>
                <p className="text-white-80">
                  Receive a reward for each client you refer — simple, secure, and hassle-free.
                </p>
              </div>
            </div>
          </div>

          {/* === CTA BLOCK === */}
          <div className={`cta-block mt-5 ${ctaVisible ? "show" : ""}`}>
            <h3 className="text-white mb-3">Receive a fee for every client you refer.</h3>
            <p className="text-white-80 mb-4">
              Register now.
            </p>
            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
              <a
                className="btn btn-primary px-4 py-3"
                href="https://chatcgt.typeform.com/to/ZyUQ1PAB"
                target="_blank"
                rel="noreferrer"
              >
                Refer a Client
              </a>

              <a
                className="btn btn-primary px-4 py-3"
                href="https://chatcgt.typeform.com/to/OBR6HLm4"
                target="_blank"
                rel="noreferrer"
              >
                Agent Registration
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Agents;
